import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getFriendCardPendingStyles = (theme: Theme) =>
  StyleSheet.create({
    receivedInvitationContainer: {
      padding: 16,
      paddingTop: 20,
      paddingBottom: 20,
      alignItems: 'center',
      minHeight: 170,
      justifyContent: 'center',
      position: 'relative',
    },
    countBadge: {
      position: 'absolute',
      top: 8,
      right: 8,
      backgroundColor: theme.primary,
      borderRadius: 12,
      minWidth: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 8,
      zIndex: 10,
      shadowColor: theme.shadow,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.2,
      shadowRadius: 4,
      elevation: 4,
    },
    countBadgeText: {
      color: theme.onPrimary,
      fontSize: 12,
      fontWeight: '700',
    },
    inviterNameText: {
      color: theme.black,
      fontSize: 16,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 4,
      paddingHorizontal: 8,
    },
    invitationMessage: {
      color: theme.gray[600],
      fontSize: 14,
      textAlign: 'center',
      marginBottom: 12,
    },
    actionRow: {
      flexDirection: 'row',
      gap: 8,
      width: '100%',
    },
    acceptButton: {
      flex: 1,
      backgroundColor: theme.success,
      paddingHorizontal: 12,
      paddingVertical: 10,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 40,
      flexDirection: 'row',
      shadowColor: theme.success,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.2,
      shadowRadius: 4,
      elevation: 3,
    },
    acceptButtonText: {
      color: theme.textOnStatusBadge,
      fontSize: 13,
      fontWeight: '700',
    },
    declineButton: {
      flex: 1,
      backgroundColor: theme.background.card,
      paddingHorizontal: 12,
      paddingVertical: 10,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 40,
      flexDirection: 'row',
      borderWidth: 2,
      borderColor: theme.gray[300],
    },
    declineButtonText: {
      color: theme.gray[700],
      fontSize: 13,
      fontWeight: '700',
    },
    buttonIcon: {
      marginRight: 4,
    },
    buttonDisabled: {
      opacity: 0.5,
    },
    sentInvitationContainer: {
      padding: 16,
      paddingTop: 20,
      paddingBottom: 20,
      alignItems: 'center',
      position: 'relative',
      minHeight: 170,
      justifyContent: 'center',
    },
    pendingRemoveButton: {
      position: 'absolute',
      top: 8,
      right: 8,
      padding: 6,
      zIndex: 10,
    },
    pendingContent: {
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      flex: 1,
    },
    waitingIcon: {
      marginBottom: 8,
    },
    waitingText: {
      color: theme.black,
      fontSize: 16,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 4,
      paddingHorizontal: 8,
    },
    pendingStatusText: {
      color: theme.gray[600],
      fontSize: 12,
      textAlign: 'center',
      fontWeight: '500',
      marginBottom: 4,
    },
    invitedEmailText: {
      color: theme.gray[500],
      fontSize: 12,
      textAlign: 'center',
      marginBottom: 16,
    },
    cancelButton: {
      backgroundColor: theme.error,
      paddingHorizontal: 20,
      paddingVertical: 10,
      borderRadius: 8,
      marginTop: 8,
    },
    cancelButtonText: {
      color: theme.textOnStatusBadge,
      fontSize: 14,
      fontWeight: '600',
    },
    errorText: {
      color: theme.error,
      fontSize: 14,
      textAlign: 'center',
    },
    showMoreButton: {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      borderRadius: 8,
      paddingVertical: 12,
      paddingHorizontal: 16,
      alignItems: 'center',
      marginTop: 8,
      borderWidth: 1,
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    showMoreText: {
      fontSize: 14,
      color: theme.white,
      fontWeight: '600',
    },
  });
